import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getComerciosPorCategoria, getCategorias, toggleSeguirComercio, notificarme } from "../api";
import { calcularDistancia } from "../utils/geo";
import "../assets/css/style.css";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-hot-toast";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Comercios = () => {
  const navigate = useNavigate();
  const { id_categoria } = useParams();
  const [categoria, setCategoria] = useState(null);
  const [loading, setLoading] = useState(true);
  const showSplash = useDynamicSplash(loading);
  const { user } = useAuth();
  const location = useLocation();
  const origen = location.state?.from || "home";
  const estaLogueado = user && user.id;
  const [comerciosConDistancia, setComerciosConDistancia] = useState([]);

  useEffect(() => {
    if (user === undefined) return;
    const cargar = async () => {
      setLoading(true);
      document.body.style.overflow = "hidden";
      try {
        const res = await getCategorias(user?.id || 0);
        const categorias = res.categorias || [];
        const encontrada = categorias.find(c => c.id.toString() === id_categoria);
        setCategoria(encontrada);

        const data = await getComerciosPorCategoria(id_categoria, user?.id || 0);
        const comerciosFinal = data.map((comercio) => {
          let distancia = "Acceso a la ubicación requerido.";

          const userLat = parseFloat(localStorage.getItem("userLat"));
          const userLng = parseFloat(localStorage.getItem("userLng"));
  
          if (userLat && userLng && comercio.latitud && comercio.longitud) {
            distancia = calcularDistancia(
              parseFloat(userLat),
              parseFloat(userLng),
              parseFloat(comercio.latitud),
              parseFloat(comercio.longitud)
            );
          }
          return {
            ...comercio,
            seguido: Number(comercio.seguido),
            distancia,
          };
        });
        setComerciosConDistancia(comerciosFinal);
      } catch (err) {
        console.error("Error cargando comercios:", err);
      } finally {
        setLoading(false);
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
      }
    };
    cargar();
  }, [id_categoria, user]);

  useEffect(() => {
    if (origen === "all") {
      window.history.replaceState({}, "", "/categorias");
    } else {
      window.history.replaceState({}, "", "/home");
    }
    window.history.pushState({}, "", window.location.pathname);
  }, []);  

  const handleToggleSeguir = async (id_comercio) => {
    if (!user || !user.id) {
      toast.dismiss();
      toast.error("Debes iniciar sesión para seguir comercios.");
      return;
    }
  
    const result = await toggleSeguirComercio(user.id, id_comercio);
  
    if (result.success) {
      setComerciosConDistancia((prev) =>
        prev.map((c) =>
          c.id_comercio === id_comercio
            ? { ...c, seguido: !!result.followed }
            : c
        )
      );
      toast.dismiss();
      toast.success(result.message);
    } else {
      toast.dismiss();
      toast.error(result.message || "No se pudo seguir el comercio.");
    }
  };  

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
        <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/categorias")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292"/>
            </svg>
          </button>
        </div>
        <h2 className="connections-title">{categoria ? categoria.nombre : "Comercios disponibles"}</h2>
      </div>
        <div className="suggestions-container" style={{marginTop:10}}>
          {comerciosConDistancia.length > 0 ? (
            comerciosConDistancia.map((c) => {
                const seguidoBool = !!c.seguido;
                const comercioLat = parseFloat(c.latitud);
                const comercioLng = parseFloat(c.longitud);
                const userLat = parseFloat(localStorage.getItem("userLat"));
                const userLng = parseFloat(localStorage.getItem("userLng"));
                let distancia = "Acceso a la ubicación requerido.";
                if (userLat && userLng && comercioLat && comercioLng && !isNaN(userLat) && !isNaN(userLng) && !isNaN(comercioLat) && !isNaN(comercioLng)) {
                  const distanciaCalculada = calcularDistancia(userLat, userLng, parseFloat(comercioLat), parseFloat(comercioLng));
                  distancia = `A <b>${distanciaCalculada}</b> de tu ubicación.`;
                }
                return (
                  <div
                    className="suggestion-item"
                    key={c.id_comercio}
                    onClick={() => navigate(`/comercio/${c.id}/${c.id_sucursal}`)}
                    //onClick={() => navigate(`/comercio/${c.id_sucursal}`)}
                    style={{ borderBottom: "1px solid #eee", paddingBottom: 6, marginBottom: 5 }}
                  >
                    <img
                      src={c.logo || "/assets/images/default.png"}
                      alt={c.nombre}
                      width="30"
                      height="30"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/assets/images/default.png";
                      }}
                    />
                    <div className="suggestion-info">
                      <h4>
                        {c.nombre}
                        <img src="/assets/images/verified.svg" className="verifiedUser" style={{ width: 300 }} alt="Verificado" />
                      </h4>
                      <p dangerouslySetInnerHTML={{ __html: distancia }} />
                    </div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleToggleSeguir(c.id_comercio);
                      }}
                      className={`follow-btn ${estaLogueado && seguidoBool ? 'btn-followed' : 'btn-follow'}`}
                    >
                      {estaLogueado && seguidoBool ? 'Seguido' : 'Seguir'}
                    </button>
                  </div>
                );
              })
          ) : (
            <div className="no-data-wrapper" style={{height:300, marginTop:110}}>
              <div className="no-data">
                <img src="/assets/images/empty.svg" alt="Sin referidos" />
                <p>
                  Aún no hay socios disponibles
                </p>
                {user?.id && (
                  categoria?.notificarme ? (
                    <button disabled className="btn-negro-aviso">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" style={{marginRight:7}}>
                        <path fill="currentColor" d="M9.998 2c3.149 0 5.744 2.335 5.984 5.355l.014.223l.004.224l-.001 3.596l.925 2.222q.034.081.053.167l.016.086l.008.132a1 1 0 0 1-.749.963l-.116.027l-.135.01l-3.501-.001l-.005.161a2.5 2.5 0 0 1-4.99 0l-.005-.161H3.999a1 1 0 0 1-.26-.034l-.124-.042a1 1 0 0 1-.603-1.052l.021-.128l.043-.128l.923-2.219L4 7.793l.004-.225C4.127 4.451 6.771 2 9.998 2M11.5 15.004h-3l.007.141a1.5 1.5 0 0 0 1.349 1.348L10 16.5a1.5 1.5 0 0 0 1.493-1.355zM9.998 3c-2.623 0-4.77 1.924-4.98 4.385l-.014.212L5 7.802V11.5l-.038.192l-.963 2.313l11.958.002l.045-.002l-.964-2.313L15 11.5V7.812l-.004-.204C14.891 5.035 12.695 3 9.998 3" strokeWidth="0.7" stroke="currentColor" />
                      </svg>
                      Anotado para avisarte
                    </button>
                  ) : (
                    <button
                      className="btn-negro-aviso"
                      onClick={async () => {
                        const result = await notificarme(user.id, parseInt(id_categoria));
                        if (result.success) {
                          toast.dismiss();
                          toast.success(result.message);
                          setCategoria((prev) => ({ ...prev, notificarme: true }));
                        } else {
                          toast.dismiss();
                          toast.error(result.message);
                        }
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" style={{marginRight:7}}>
                        <path fill="currentColor" d="M9.998 2c3.149 0 5.744 2.335 5.984 5.355l.014.223l.004.224l-.001 3.596l.925 2.222q.034.081.053.167l.016.086l.008.132a1 1 0 0 1-.749.963l-.116.027l-.135.01l-3.501-.001l-.005.161a2.5 2.5 0 0 1-4.99 0l-.005-.161H3.999a1 1 0 0 1-.26-.034l-.124-.042a1 1 0 0 1-.603-1.052l.021-.128l.043-.128l.923-2.219L4 7.793l.004-.225C4.127 4.451 6.771 2 9.998 2M11.5 15.004h-3l.007.141a1.5 1.5 0 0 0 1.349 1.348L10 16.5a1.5 1.5 0 0 0 1.493-1.355zM9.998 3c-2.623 0-4.77 1.924-4.98 4.385l-.014.212L5 7.802V11.5l-.038.192l-.963 2.313l11.958.002l.045-.002l-.964-2.313L15 11.5V7.812l-.004-.204C14.891 5.035 12.695 3 9.998 3" strokeWidth="0.7" stroke="currentColor" />
                      </svg>
                      Avisarme
                    </button>
                  )
                )}
              </div>
            </div>
          )}
        </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Comercios;
